export class ImageProcessor {
  constructor(callback) {
    this._setupCanvas();
    this._callback = callback;
    this._thumbSizes = {
      extra_large: 3840,
      large: 960,
      small: 320,
      tiny: 80
    };
    // this._thumbSizes = [
    //     {name:"full"},
    //     {name:"extra_large", size: 3840},
    //     {name:"large", size: 960},
    //     {name:"small", size: 320},
    //     {name:"tiny", size: 80}
    // ];
  }
  _setupCanvas() {
    if (typeof OffscreenCanvas !== 'undefined') {
      this._canvas = new OffscreenCanvas(1, 1);
      this._resizeCanvas = new OffscreenCanvas(1, 1);
    } else if (typeof document !== 'undefined') {
      this._canvas = document.createElement('canvas');
      this._resizeCanvas = document.createElement('canvas');
    } else {
      console.error('Offscreen Canvas not supported and using a worker.');
      throw new Error('Error Processing Images');
    }
    this._canvas._ctx = this._canvas.getContext('2d');
    this._resizeCanvas._ctx = this._resizeCanvas.getContext('2d');
    this._resizeCanvas._ctx.imageSmoothingQuality = 'high';
  }
  async convert(photo, isMobile = false) {
    return new Promise(async (resolve, reject) => {
      try {
        // if createImageBitmap or OffscreenCanvas are not supported, or we are on mobile
        // (where webp conversion is too costly), skip converting the image to a webp and
        // just return the original
        if (!self.createImageBitmap || !self.OffscreenCanvas || isMobile) {
          resolve({
            exif: photo.item.slice(0, 131072),
            'full.jpg': photo.item
          });
        } else {
          function contextLost() {
            reject('WebGl Context Lost');
          }
          this._canvas.addEventListener('webglcontextlost', contextLost);
          function creationError() {
            reject('WebGl Creation Error');
          }
          this._canvas.addEventListener('webglcontextcreationerror', creationError);

          // draw the image to the canvas
          let drawable = await createImageBitmap(photo.item);
          const size = {
            w: photo.exif.image_width || drawable.width,
            h: photo.exif.image_height || drawable.height
          };
          this._canvas.width = size.w;
          this._canvas.height = size.h;
          this._canvas._ctx.drawImage(drawable, 0, 0, size.w, size.h);
          drawable.close();

          // determine what file sizes we need to create
          let files = {
            exif: photo.item.slice(0, 131072),
            'full.webp': await this._canvas.convertToBlob({ type: 'image/webp', quality: 0.75 })
          };
          // upload thumbnails
          for (var key in this._thumbSizes) {
            files[key + '.webp'] = await this._resize(size.w, size.h, this._thumbSizes[key]);
          }

          this._canvas.removeEventListener('webglcontextlost', contextLost);
          this._canvas.removeEventListener('webglcontextcreationerror', creationError);
          resolve(files);
        }
      } catch (e) {
        reject(e);
      }
    });
  }
  _resize(sw, sh, maxDimension) {
    let dw, dh;
    if (sw > sh) {
      dw = maxDimension;
      dh = Math.floor((sh * dw) / sw);
    } else {
      dh = maxDimension;
      dw = Math.floor((sw * dh) / sh);
    }
    this._resizeCanvas.width = dw;
    this._resizeCanvas.height = dh;
    this._resizeCanvas._ctx.drawImage(this._canvas, 0, 0, sw, sh, 0, 0, dw, dh);
    return this._resizeCanvas.convertToBlob({ type: 'image/webp', quality: 0.75 });
  }
}
